import { deleteOrNop, setSafe } from "../../../util/storeHelper";
import { clearLastActiveProfile, setCurrentProfile, setNextProfile, } from "../actions/settings";
export const settingsReducer = {
    reducers: {
        [setNextProfile]: (state, payload) => setSafe(state, ["nextProfileId"], payload.profileId),
        [setCurrentProfile]: (state, payload) => {
            const { gameId, profileId } = payload;
            let res = setSafe(state, ["activeProfileId"], profileId);
            if (gameId !== undefined) {
                res = setSafe(res, ["lastActiveProfile", gameId], profileId);
            }
            return res;
        },
        [clearLastActiveProfile]: (state, payload) => 
        // Theoretically we could assign the next available profile here instead
        //  of completely deleting the game entry..
        deleteOrNop(state, ["lastActiveProfile", payload.gameId]),
    },
    defaults: {
        nextProfileId: undefined,
        activeProfileId: undefined,
        lastActiveProfile: {},
    },
};
